import React from 'react';
import SamplePromotion from './SamplePromotion';
import SponsorSlot from './SponsorSlot';
import PageHeader from './PageHeader';
import PasswordField from './PasswordField';
const { getApiUrl } = require('../config/serverEndpoint');
import LegalLinks from './LegalLinks';
import { useState } from 'react';
import { UserRound } from 'lucide-react';
import NativeIdentityButton from './NativeIdentityButton';
const { nativeIdentityPlugin } = require('../utils/nativeIdentity');
import GoogleIdentityButton from './GoogleIdentityButton';
import FacebookIdentityButton from './FacebookIdentityButton';
import AppleIdentityButton from './AppleIdentityButton';

export default function LoginScreen({ infoMessage, loginError, onLogin, onGoogleCredential, onFacebookCredential, onAppleCredential, onNavigateToRegister }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (event) => {
    event?.preventDefault();
    if (!username.trim() || !password) {
      setError('Kullanıcı adı ve şifre zorunludur.');
      return;
    }
    setError('');
    onLogin(username.trim(), password);
  };

  return <main className="kelimo-ui kelimo-page reference-auth-page">
    <PageHeader title="Giriş"/>
    <form onSubmit={handleLogin} className="reference-auth-content">
      {infoMessage&&<p role="status" className="reference-status success">{infoMessage}</p>}
      <div className="reference-social-login"><AppleIdentityButton onCredential={onAppleCredential}/>
        {nativeIdentityPlugin('google')?<NativeIdentityButton provider="google" onCredential={onGoogleCredential}/>:process.env.REACT_APP_KELIMO_GOOGLE_CLIENT_ID&&!window.Capacitor?.isNativePlatform?.()?<GoogleIdentityButton onCredential={onGoogleCredential} label=""/>:<span className="social-unavailable">Google · Yakında</span>}
        {nativeIdentityPlugin('facebook')?<NativeIdentityButton provider="facebook" onCredential={onFacebookCredential}/>:process.env.REACT_APP_KELIMO_FACEBOOK_APP_ID&&!window.Capacitor?.isNativePlatform?.()?<FacebookIdentityButton onCredential={onFacebookCredential} label="Facebook ile devam et"/>:<span className="social-unavailable">Facebook · Yakında</span>}
      </div><div className="reference-or"><span>veya</span></div>
      <label className="reference-form-field"><span>Oyuncu adı</span><span className="reference-input-wrap"><UserRound size={18} aria-hidden="true"/><input type="text" value={username} onChange={e=>setUsername(e.target.value)} autoCapitalize="none" autoCorrect="off" spellCheck={false} autoComplete="username" required/></span></label>
      <PasswordField label="Şifre" id="login-password" value={password} onChange={e=>setPassword(e.target.value)} autoComplete="current-password" required/>
      {(error || loginError)&&<p role="alert" className="reference-status error">{error || loginError}</p>}
      <button type="submit" className="reference-primary">Giriş yap</button>
      <div className="reference-auth-links"><button type="button" onClick={onNavigateToRegister}>Yeni hesap oluştur</button><a href={getApiUrl('/account-recovery')} target="_blank" rel="noopener noreferrer">Şifremi unuttum</a></div><LegalLinks/>
    </form>
    <div className="login-promotion"><SponsorSlot placement="login" fallback={<SamplePromotion/>}/></div>
  </main>;
}
